// Module
var code = "<p>[# summary]</p> <h3 id=\"aktif-symbol\">Aktif {symbol}</h3> <p>{description}<br>Piyasaya süren {issuer}</p> <p>Euro (işaret: €; sembol: EUR) Avrupa bölgesindeki katılımcı ülkelerin resmi para birimidir.</p> ";
// Exports
export default code;